import { PREDICATE_RECOMMENDATION_RESULT_TEXT } from 'app/KinerjaPage/pages/PelaksanaanV2/constants/predicateRecommendation'

import type { ColumnConfig } from 'app/KinerjaShared/components/PenetapanPredikatTable/type'
import type { PredikatKinerjaTypes } from 'app/KinerjaShared/stores/penetapan-predikat-kinerja-store'
import type { StatusPengirimanFilterTypes } from 'app/KinerjaShared/stores/penetapan-predikat-kinerja-store'

export const PREDIKAT_LABELS: Record<PredikatKinerjaTypes, string> = {
  ...PREDICATE_RECOMMENDATION_RESULT_TEXT,
  UNFINISHED_PENILAIAN: 'Penilaian Belum Selesai',
  PREDIKAT_NOT_SET: 'Belum Ditetapkan',
}

export const STATUS_PENGIRIMAN_FILTER_LABELS: Record<
  StatusPengirimanFilterTypes,
  string
> = {
  ALL: 'Semua Status Pengiriman',
  SENT: 'Sudah Dikirim',
  NOT_SENT: 'Belum Terkirim',
}

export const ALL_COLUMNS: Array<ColumnConfig> = [
  { key: 'checkbox', label: '', visible: true },
  {
    key: 'name',
    label: 'Nama',
    className: 'overflow-wrap-anywhere',
    headerClassName: 'min-w-32',
    visible: true,
  },
  {
    key: 'nip',
    label: 'NIP',
    className: 'text-center',
    headerClassName: 'text-center',
    visible: true,
  },
  {
    key: 'jabatan',
    label: 'Jabatan',
    className: 'text-center overflow-wrap-anywhere',
    headerClassName: 'text-center min-w-32',
    visible: true,
  },
  {
    key: 'satuanPendidikan',
    label: 'Satuan Pendidikan',
    className: 'text-center min-w-32 overflow-wrap-anywhere',
    headerClassName: 'text-center min-w-32',
    visible: true,
  },
  {
    key: 'praktikKinerja',
    label: 'Rating Praktik Kinerja',
    className: 'text-center',
    headerClassName: 'text-center',
    visible: true,
  },
  {
    key: 'perilakuKerja',
    label: 'Rating Perilaku Kerja',
    className: 'text-center',
    headerClassName: 'text-center',
    visible: true,
  },
  {
    key: 'predikatKinerja',
    label: 'Predikat Kinerja',
    className: 'text-center',
    headerClassName: 'text-center',
    visible: true,
  },
  {
    key: 'statusPengiriman',
    label: 'Status Pengiriman',
    className: 'text-center',
    headerClassName: 'text-center',
    visible: true,
  },
  {
    key: 'action',
    label: 'Aksi',
    className: 'text-center w-48',
    headerClassName: 'text-center w-48',
    visible: true,
  },
]
